import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import FilePreview from "../../UI/FilePreview";

interface PortalFilesCardProps {
    project: any;
}
const PortalFilesCard: React.FC<PortalFilesCardProps> = ({ project }) => {
    if (!project.values || project.values?.filter((val) => val.value_type === "file").length === 0) {
        return null;
    }

    // Do not show this card on Jobsite Command
    const urlPath = new URL(window.location.href).pathname;
    if (urlPath.includes("dashboard")) {
        return null;
    }
    return (
        <div className="flex flex-col gap-2">
            <div className="flex flex-row items-center gap-2">
                <FontAwesomeIcon icon={faDownload} className="text-plot-purple" />
                <div className="text-lg font-semibold text-gray-900 dark:text-plot-darkmode-white">
                    Available Downloads
                </div>
            </div>
            <div className="grid grid-cols-2 gap-3 p-4 rounded-lg shadow-sm border bg-gray-50 dark:bg-neutral-800 border-gray-200 dark:border-neutral-700">
                {project.values
                    ?.filter((val) => val.value_type === "file")
                    .map((file) => (
                        <FilePreview
                            key={file.id}
                            content_type={file.value_text.split(".").pop()?.toLowerCase()}
                            uri={`/projects/${project.unique_token}/values/${file.id}/attachment`}
                            downloadURI={`/projects/${project.unique_token}/values/${file.id}/attachment`}
                            filename={file.value_title || file.value_text}
                        />
                    ))}
            </div>
        </div>
    );
};

export default PortalFilesCard;
